<template>
    <div class="ChangePasswordModal">
        <div class="main">
            <h1>Change Password</h1>
            <FormPasswordInput
                v-model="$v.currentPassword.$model"
                label="Your Current Password"
                :errors="$v.currentPassword.$error ? [
                    !$v.currentPassword.required && 'Current password is required',
                ] : null"
            />
            <FormPasswordInput
                v-model="$v.newPassword.$model"
                lazy
                label="New Password"
                :errors="$v.newPassword.$error ? [
                    !$v.newPassword.required && 'New password is required',
                    !$v.newPassword.minLength && 'Password has to be at least 6 characters long',
                ] : null"
            />
            <FormPasswordInput
                v-model="$v.newPasswordConfirm.$model"
                lazy
                label="Repeat New Password"
                :errors="$v.newPasswordConfirm.$error ? [
                    !$v.newPasswordConfirm.sameAsPassword && 'Passwords don\'t match',
                ] : null"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleSubmit" :disabled="submitPending">Update Password</Button>
        </div>
    </div>
</template>

<script>
import * as api from '@/api';
import { required, sameAs, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'ChangePasswordModal',

    data: () => ({
        currentPassword: null,
        newPassword: null,
        newPasswordConfirm: null,
        submitPending: false,
    }),

    validations: {
        currentPassword: {
            required,
        },
        newPassword: {
            required,
            minLength: minLength(6),
        },
        newPasswordConfirm: {
            required,
            sameAsPassword: sameAs('newPassword'),
        },
    },

    methods: {
        async handleSubmit() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            if (this.submitPending) return;
            this.submitPending = true;

            const { currentPassword, newPassword } = this;
            const userId = this.$store.state.auth.user.id;
            const res = await api.changePassword(userId, { currentPassword, newPassword });
            this.submitPending = false;

            if (res.error) {
                return this.$awn.alert('Failed to update password!');
            }

            this.$awn.success('Your password has been changed!');
            this.$emit('close');
        },

        handleCancel() {
            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ChangePasswordModal {
    @extend %modal;

    .actions {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
